import { MutationTree } from 'vuex';
import { DeviceInfo } from '@/common/apis/DeviceApi';
import { RelaysState, IRelayState } from './types';
import Vue from 'vue';

export const mutations: MutationTree<RelaysState> = {
    loaded(state, args: {deviceNumber: string, relays: boolean[]}) {
        const relays: IRelayState[] = [];
        for (const relay of args.relays) {
            Vue.set(relays, relays.length, {
                isLoading: false,
                isOn: relay,
            });
            // relays.push({
            //     isLoading: false,
            //     isOn: relay,
            // });
        }
        Vue.set(state.relays, args.deviceNumber, relays);
    },
    clear(state) {
        state.locked = true;
        state.relays = {};
    },
    lock(state) {
        Vue.set(state, 'locked', true);
    },
    unlock(state) {
        Vue.set(state, 'locked', false);
    },
    toggleRelay(state, args: { deviceNumber: string, relayNumber: number}) {
        const relays = state.relays[args.deviceNumber];
        if (!relays || relays.length <= args.relayNumber) {
            throw { message: 'Relay not found'};
        }

        const relay = relays[args.relayNumber];
        Vue.set(relay, 'isLoading', false);
        Vue.set(relay, 'isOn', !relay.isOn);
    },
    turnOn(state, args: { deviceNumber: string, relayNumber: number}) {
        const relays = state.relays[args.deviceNumber];
        if (!relays || relays.length <= args.relayNumber) {
            throw { message: 'Relay not found'};
        }

        const relay = relays[args.relayNumber];
        Vue.set(relay, 'isLoading', false);
        Vue.set(relay, 'isOn', true);
    },
    turnOff(state, args: { deviceNumber: string, relayNumber: number}) {
        const relays = state.relays[args.deviceNumber];
        if (!relays || relays.length <= args.relayNumber) {
            throw { message: 'Relay not found'};
        }

        const relay = relays[args.relayNumber];
        Vue.set(relay, 'isLoading', false);
        Vue.set(relay, 'isOn', false);
    },
    setLoading(state, args: { deviceNumber: string, relayNumber: number, loading?: boolean}) {
        const relays = state.relays[args.deviceNumber];
        if (!relays || relays.length <= args.relayNumber) {
            throw { message: 'Relay not found'};
        }
        const relay = relays[args.relayNumber];
        Vue.set(relay, 'isLoading', args.loading === undefined ? true : args.loading);
    },
};
